import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from 'app/slice/selectors';
import { selectIsProfileCompleted, selectIspracticeprofilecompleted } from 'app/slice';

interface ProfileCompletionGuardProps {
  children: React.ReactNode;
}

export const ProfileCompletionGuard: React.FC<ProfileCompletionGuardProps> = ({ children }) => {
  const location = useLocation();
  const user = useSelector(selectUser);
  const isProfileCompleted = useSelector(selectIsProfileCompleted);
  const isPracticeProfileCompleted = useSelector(selectIspracticeprofilecompleted);
  
  // Get user data from localStorage if Redux state is empty (on refresh)
  const localStorageUser = user || JSON.parse(localStorage.getItem('user') || 'null');
  
  
  
  // Check if both profiles are completed (use state flags with fallback to user object from localStorage)
  const isBothProfilesCompleted = (isProfileCompleted && isPracticeProfileCompleted) || 
    (localStorageUser?.isProfileCompleted && localStorageUser?.isPracticeProfileComplete);


  // If profiles are not completed and user is trying to access restricted routes, redirect to user profile
  if (!isBothProfilesCompleted) {
    return <Navigate to="/account-settings/user-profile" replace />;
  }

  // If profiles are completed, allow access to the protected route
  return <>{children}</>;
}; 